
export const PageTitleStyles = {
    fontSize: "20px"
}
export const ButtonGridStyles = {
    marginTop: (theme) => theme.spacing(2)
}
export const ButtonStylesStyles = {
    marginBottom: (theme) => theme.spacing(2),
    marginTop: (theme) => theme.spacing(1.5)
}
export const ButtonTextStyles = {
    color: "white"
}
export const ButtonGridSmallStyles = {
    marginTop: "20px"
}
export const VAListItemStyles = {
    padding: (theme) => theme.spacing(2),
}
export const headerTextStyles = {
    marginBottom: (theme) => theme.spacing(1),
}
